import { render, staticRenderFns } from "./InputAdminName.vue?vue&type=template&id=6039d7f9&scoped=true"
import script from "./InputAdminName.vue?vue&type=script&lang=js"
export * from "./InputAdminName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039d7f9",
  null
  
)

export default component.exports